/**
 * OVERLAPPENDE HEADER FOR "HERO FULLSKJERM (FORSIDE)"
 *
 * To jobber:
 *
 *   1. Avgjore om hero-seksjonen faktisk er den forste seksjonen pa siden. Er den ikke det, fjernes
 *      attributtet allow-transparent-header fra elementet, og da slutter alle reglene i
 *      hero-fullscreen-header.css a matche. CSS-en eier utseendet, denne filen eier betingelsen.
 *
 *      Sjekken ligger her og ikke i CSS fordi :first-child viste seg a vaere for skjort: apper og
 *      temaeditoren skyter inn egne elementer i #main, sa seksjonen kan vaere synlig overst uten a
 *      vaere forstebarn. Her kan vi i stedet se bort fra alt som ikke er en .shopify-section.
 *
 *   2. Legge pa klassen header--hero-scrolled sa snart siden er scrollet, og ta den av pa toppen.
 *
 * Merk at den transparente tilstanden er default i CSS - dette skriptet skrur den AV. Gjorde vi det
 * omvendt, ville headeren blinket rosa for skriptet rakk a kjore.
 *
 * Klassen settes pa selve <x-header>-elementet med vilje: assets/section-header.js har en
 * MutationObserver pa class-attributtet der, sa logobyttet synkroniseres av seg selv i samme
 * oyeblikk. Da slipper vi a duplisere den logikken her.
 */
(function () {
  'use strict';

  var SCROLLED_CLASS = 'header--hero-scrolled';

  /* Samme terskel som section-header.js bruker for sitt eget logobytte, sa de to aldri er uenige. */
  var THRESHOLD = 2;

  var bound = false;

  function getHeader() {
    return document.querySelector('.shopify-section--header .header');
  }

  function getHero() {
    return document.querySelector('#main [data-hero-fullscreen]');
  }

  /*
   * Forste SEKSJON i #main, ikke forste element. Alt som ikke er en .shopify-section hoppes over,
   * slik at innskutte app-elementer ikke teller som "noe foran hero-en".
   */
  function heroIsFirstSection() {
    var main = document.getElementById('main');
    var hero = getHero();
    if (!main || !hero) return false;

    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return false;

    return sections[0].contains(hero);
  }

  function sync() {
    var header = getHeader();
    if (!header) return;

    var scrolled = (window.scrollY || document.documentElement.scrollTop || 0) > THRESHOLD;
    header.classList.toggle(SCROLLED_CLASS, scrolled);
  }

  function init() {
    var header = getHeader();
    var hero = getHero();
    if (!header || !hero) return;

    if (!heroIsFirstSection()) {
      /*
       * Seksjonen er flyttet ned. Vi fjerner attributtet i stedet for a legge pa en "av"-klasse,
       * fordi attributtet er selve betingelsen CSS-en spor etter. Flyttes seksjonen tilbake, bygger
       * temaeditoren den om og Liquid skriver attributtet ut pa nytt.
       */
      hero.removeAttribute('allow-transparent-header');
      header.classList.remove(SCROLLED_CLASS);
      return;
    }

    sync();

    if (!bound) {
      bound = true;
      window.addEventListener('scroll', sync, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /*
   * I temaeditoren bygges seksjoner om ved hver endring, og rekkefolgen kan endres uten omlasting.
   * Da ma betingelsen testes pa nytt.
   */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:section:unload', init);
})();
